import { render } from "./NewsUpdate.vue?vue&type=template&id=a3249f5a&scoped=true"
import script from "./NewsUpdate.vue?vue&type=script&lang=js"
export * from "./NewsUpdate.vue?vue&type=script&lang=js"

import "./NewsUpdate.vue?vue&type=style&index=0&id=a3249f5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3249f5a"]])

export default __exports__